import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import Address from './Address';
import Equipment from './Equipment';
import Staff from './Staff';

export default class EquipmentMaintenance extends BaseModel {
  constructor({
    id,
    number,
    designation,
    equipment = undefined,
    mechanicStaffId = undefined,
    addressId = undefined,
    maintenanceDate = undefined,
    maintenanceDateActive = true,
    maintenanceDateInterval = undefined,
    maintenanceCounter = undefined,
    maintenanceCounterActive = true,
    maintenanceCounterInterval = undefined,
    description,
    memo = undefined,
    no = undefined,
  }) {
    super(id, number || no, designation);
    this.equipment = equipment ? new Equipment(equipment) : undefined;
    this.mechanicStaffId = mechanicStaffId ? new Staff(mechanicStaffId) : null;
    this.addressId = addressId ? new Address(addressId) : undefined;
    this.maintenanceDate = maintenanceDate;
    this.maintenanceDateActive = maintenanceDateActive;
    this.maintenanceDateInterval = maintenanceDateInterval;
    this.maintenanceCounter = maintenanceCounter;
    this.maintenanceCounterActive = maintenanceCounterActive;
    this.maintenanceCounterInterval = maintenanceCounterInterval;
    this.description = description;
    this.memo = memo;
  }

  static get baseModuleForRedirection() {
    return 'equipment-base';
  }
  get baseModuleForRedirection() {
    return EquipmentMaintenance.baseModuleForRedirection;
  }

  static get config() {
    const config = BaseModel.config;
    config['importable'] = false;
    config['addable'] = false;
    return config;
  }

  get config() {
    const config = BaseModel.config;
    config['importable'] = false;
    return config;
  }

  static get fkName() {
    return 'equipment_maintenance_id';
  }
  static get apiRoute() {
    return 'equipment_maintenance';
  }
  static get detailPageRoute() {
    return 'equipmentMaintenanceDetail';
  }
  static get listPageRoute() {
    return 'equipmentDetail';
  }
  static get joinFilterColumns() {
    return ['search'];
  }
  get fkName() {
    return EquipmentMaintenance.fkName;
  }
  get apiRoute() {
    return EquipmentMaintenance.apiRoute;
  }
  get listPageRoute() {
    return EquipmentMaintenance.listPageRoute;
  }
  get detailPageRoute() {
    return EquipmentMaintenance.detailPageRoute;
  }
  static get attrsToStoreInForm() {
    return ['number', 'designation', 'equipment'];
  }
  get attrsToStoreInForm() {
    return BaseModel.attrsToStoreInForm;
  }
  get joinFilterColumns() {
    return EquipmentMaintenance.joinFilterColumns;
  }

  static get entityListDisplayAttrs() {
    return this.getAttributes(
      ['number', 'designation'],
      ['mechanicStaffId', 'addressId'],
    );
  }

  static get joinAttrsKey() {
    return ['number', 'designation', 'equipment'];
  }

  get createInitColumns() {
    return {};
  }

  static get orderKey() {
    return 'Equipment(number)';
  }

  static get browserDisplayAttrs() {
    return this.getAttributes([
      'equipment',
      'number',
      'designation',
      'maintenanceDateActive',
      'maintenanceCounterActive',
    ]);
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE({}, {maxWidth: '1fr'}),
      this.DESIGNATION_ATTRIBUTE(),
      new AT.FkEquipmentAttribute({
        name: 'equipment',
        joinPath: ['equipment!fk_equipment_maintenance_equipment_id_equipment'],
        tableProperties: {
          header: 'hit-base.common.equipment',
        },
      }),
      new AT.FkStaffAttribute({
        name: 'mechanicStaffId',
        column: 'mechanic_staff_id',
        fkToUpdate: 'mechanic_staff_id',
        joinPath: ['staff!fk_equipment_maintenance_mechanic_staff_id_staff'],
        tableProperties: {
          header: 'hit-app.equipment-maintenance.mechanic',
          maxWidth: '1fr',
        },
      }),
      new AT.FkAddressAttribute({
        name: 'addressId',
        joinPath: ['address!fk_equipment_maintenance_address_id_address'],
        tableProperties: {
          header: 'hit-app.equipment-maintenance.service-company',
          maxWidth: '1fr',
        },
      }),
      new AT.DateAttribute({
        name: 'maintenanceDate',
        column: 'maintenance_date',
        tableProperties: {
          header: 'hit-app.equipment-maintenance.maintenance-date',
          maxWidth: '1fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'maintenanceDateActive',
        column: 'maintenance_date_active',
        default: true,
        tableProperties: {
          maxWidth: '4rem',
        },
      }),
      new AT.DecimalAttribute({
        name: 'maintenanceDateInterval',
        column: 'maintenance_date_interval',
        decimalPrecision: 0,
        creationValue: 0,
        tableProperties: {
          maxWidth: '1fr',
        },
      }),
      new AT.DecimalAttribute({
        name: 'maintenanceCounter',
        column: 'maintenance_counter',
        decimalPrecision: 2,
        creationValue: 0,
        tableProperties: {
          header: 'hit-app.equipment-maintenance.maintenance-counter',
          maxWidth: '1fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'maintenanceCounterActive',
        column: 'maintenance_counter_active',
        default: true,
        tableProperties: {
          maxWidth: '4rem',
        },
      }),
      new AT.DecimalAttribute({
        name: 'maintenanceCounterInterval',
        column: 'maintenance_counter_interval',
        decimalPrecision: 2,
        creationValue: 0,
        tableProperties: {
          maxWidth: '1fr',
        },
      }),
      new AT.RichTextAttribute({
        name: 'description',
        tableProperties: {
          header: 'hit-base.common.description',
          maxWidth: '1fr',
        },
      }),
      this.MEMO_RICH_TEXT_ATTRIBUTE(),
    ];
  }
}
